import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { FC } from 'react';

import { DashboardContentLayout } from '~ui-components/components/atoms/dashboard-content-layout';
import { DatasetInfo } from '~ui-components/components/organisms/dataset-view-panels/dataset-info';
import {
	DatasetPreview,
	DatasetPreviewProps,
} from '~ui-components/components/organisms/dataset-view-panels/dataset-preview';

export type DatasetViewProps = DatasetPreviewProps;

export const DatasetView: FC<DatasetViewProps> = ({
	currentTab,
	onTabChange,
	isExpandedView,
	onExpandViewChange,
	slots: Slots,
}) => {
	if (isExpandedView)
		return (
			<Box
				component="main"
				sx={{
					'--Content-margin': '0 auto',
					'--Content-maxWidth': 'var(--maxWidth-xl)',
					'--Content-paddingX': '24px',
					'--Content-paddingY': { xs: '24px', lg: '64px' },
					'--Content-padding':
						'var(--Content-paddingY) var(--Content-paddingX)',
					'--Content-width': '100%',
					display: 'flex',
					flex: '1 1 auto',
					flexDirection: 'column',
				}}
			>
				<Box
					sx={{
						m: 'var(--Content-margin)',
						p: 'var(--Content-padding)',
						width: '100dvw',
						height: '100dvh',
					}}
				>
					<DatasetPreview
						currentTab={currentTab}
						onTabChange={onTabChange}
						isExpandedView={isExpandedView}
						onExpandViewChange={onExpandViewChange}
						slots={Slots}
					/>
				</Box>
			</Box>
		);

	return (
		<DashboardContentLayout>
			<Grid container spacing={4}>
				{!isExpandedView && (
					<Grid lg={4} xs={12}>
						<DatasetInfo />
					</Grid>
				)}
				<Grid lg={8} xs={12}>
					<DatasetPreview
						currentTab={currentTab}
						onTabChange={onTabChange}
						isExpandedView={isExpandedView}
						onExpandViewChange={onExpandViewChange}
						slots={Slots}
					/>
				</Grid>
			</Grid>
		</DashboardContentLayout>
	);
};
